export interface Annotation3D {
  id: string;
  kind: "comment" | "issue" | "approval";
  position: [number, number, number];
  featureId?: string;
  text: string;
  author: string;
  createdAt: number;
  resolved: boolean;
}

let counter = 0;
export function annotationId(): string {
  return `ann_${Date.now().toString(36)}_${(counter++).toString(36)}`;
}
